module.exports = __webpack_public_path__ + "assets/disclaimer-icon.ff295d7e.svg";